import { scrollAnimation } from "@/utils/scroll.js";
export const commonFuc = {
    data() {
        return {
            inputBlurTimer: null,
            isShowInputBlurTips: {},
            whiteidEnable: true,
        }
    },
    methods: {
        isCloud() {
            if (
                isNaN(this.featureList['cloud'].timeRemaining) ||
                (!isNaN(this.featureList['cloud'].timeRemaining) &&
                    this.featureList['cloud'].timeRemaining <= 0)
            ) {
                return false
            } else {
                return true
            }
        },
        openUrl(url) {
            if (window.electron) {
                window.electron.shell.openExternal(url)
            } else {
                window.open(url)
            }
        },
        orderPayWeixinGuideShow() {
            this.$refs.dialogpay.orderPayWeixinGuideShow()
        },
        eleFocusIn(inputTitle) {
            this.isShowInputBlurTips[inputTitle] = false;
            this.$forceUpdate();
            clearTimeout(this.inputBlurTimer);
            this.inputBlurTimer = null;
        },
        eleFocusOut(inputTitle, isScroll = true) {
            let element = document.documentElement.scrollTop ? document.documentElement : document.body;
            this.isShowInputBlurTips[inputTitle] = true;
            if (isScroll) {
                if (window.scrollTimer) {
                    clearTimeout(window.scrollTimer);
                    window.scrollTimer = null;
                }
                window.canRun = false;
                scrollAnimation(element.scrollTop, this.$refs[inputTitle].$el.getBoundingClientRect().top + element.scrollTop - 200);
            }
            this.$forceUpdate();
        },
        singleInputFocusOut(inputTitle, isScroll = true) {
            setTimeout(() => {
                if (this[inputTitle]) {
                    this.eleFocusOut(inputTitle, isScroll);
                }
            }, 2e3);
        },
        scrollToFuc(type) {
            console.log(this.$ref);
            if (window.scrollTimer) {
                clearTimeout(window.scrollTimer);
                window.scrollTimer = null;
            }
            window.canRun = false;
            scrollAnimation(
                document.documentElement.scrollTop,
                this.$refs.test.scrollTop
            );
        },
        debounce (func, wait = 1000, immediate = true) {
            let timer
            return function () {
              const context = this
              const args = arguments
              if (timer) clearTimeout(timer)
              if (immediate) {
                const callNow = !timer
                timer = setTimeout(() => {
                  timer = null
                }, wait)
                if (callNow) func.apply(context, args)
              } else {
                timer = setTimeout(() => {
                  func.apply(context, args)
                }, wait)
              }
            }
          }
    }
}